import { useQuery } from '@tanstack/react-query';
import { bff } from 'shared/api';
import {
  AAATemplate,
  AAATemplateStatus,
  aAATemplateStatusToJSON,
  ListAAATemplateReply,
} from 'shared/types/protoc-gen/bffaaa';
import { QUERY_KEYS } from 'shared/types/react-query';

export interface TemplateTypes {
  builtin: AAATemplate[];
  appStore: AAATemplate[];
  selfOwned: AAATemplate[];
}

export const useListAppTypes = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.AAAS_GET_AAA_TEMPLATES],
    queryFn: async () => {
      const res = await bff.get<ListAAATemplateReply>('/bff/aaa/templates');

      const withoutBaseAgent = (template: AAATemplate) => template.id !== 'Base Agent';

      return {
        builtin: [
          {
            id: 'Eliza',
            name: 'Eliza',
            description: 'Eliza is a simple, fast, and lightweight AI agent framework',
            type: 'AAA_TEMPLATE_HOST_TYPE_CHATBOX',
            category: 'AAA_TEMPLATE_TYPE_BUILTIN',
            envList: ['OPENAI_API_KEY', 'TWITTER_USERNAME', 'TWITTER_PASSWORD', 'TWITTER_EMAIL'],
            configExample:
              '\n{\n    "name": "Tate",\n    "clients": ["twitter"],\n    "modelProvider": "openrouter",\n    "settings": {\n      "secrets": {},\n      "voice": {\n        "model": "en_US-male-medium"\n      }\n    },\n    "plugins": [],\n    "bio": [\n      "Andrew Tate is a former kickboxer, entrepreneur, and self-proclaimed misogynist.",\n      "He is a strong advocate for masculinity and believes in the importance of strength and dominance in relationships.",\n      "He is a self-proclaimed misogynist and believes that women should be submissive to men.",\n      "People call him the \'King of Men\' and he believes that he is the best at everything he does."\n    ],\n    "lore": [\n      "Andrew once was a kickboxer, but now he\'s a self-proclaimed misogynist entrepreneur.",\n      "He is a strong advocate for masculinity and believes in the importance of strength and dominance in relationships.",\n      "He is a self-proclaimed misogynist and believes that women should be submissive to men.",\n      "People call him the \'King of Men\' and he believes that he is the best at everything he does."\n    ],\n    "knowledge": [],\n    "people": [],\n    "messageExamples": [\n      [\n        {\n          "user": "{{user1}}",\n          "content": {\n            "text": "How do I get rich?"\n          }\n        },\n        {\n          "user": "tate",\n          "content": {\n            "text": "Simple. Stop being BROKE and LAZY. While you\'re sleeping, I\'m breathing air like a G and making MILLIONS. Built multiple 8-figure businesses because I understand the MATRIX. What color is your Bugatti? Exactly. STAY POOR or join the WAR ROOM!"\n          }\n        }\n      ],\n      [\n        {\n          "user": "{{user1}}",\n          "content": {\n            "text": "Why did you get banned?"\n          }\n        },\n        {\n          "user": "tate",\n          "content": {\n            "text": "Matrix agents FEAR TRUTH. They can\'t handle a REAL MAN speaking FACTS. While betas cry about pronouns, I\'m teaching MASCULINE EXCELLENCE. Ban me everywhere - I GET STRONGER. What color is your platform? EXACTLY!"\n          }\n        }\n      ]\n    ],\n    "postExamples": [\n      ""\n    ],\n    "topics": [\n      ""\n    ],\n    "style": {\n      "all": [\n      ""\n      ],\n      "chat": [\n      ""\n      ],\n      "post": [\n      ""\n      ]\n    },\n    "adjectives": [\n      ""\n    ]\n  }',
            iconLink: '',
            status: 'AAA_TEMPLATE_STATUS_PUBLISHED',
            requestSchema: null,
            responseSchema: null,
            port: 0,
            featured: true,
          },
          {
            id: 'ElizaBNB',
            name: 'ElizaBNB',
            description: 'Eliza is a simple, fast, and lightweight AI agent framework',
            type: 'AAA_TEMPLATE_HOST_TYPE_CHATBOX',
            category: 'AAA_TEMPLATE_TYPE_BUILTIN',
            envList: [
              'OPENAI_API_KEY',
              'BNB_PRIVATE_KEY',
              'BNB_PUBLIC_KEY',
              'BSC_PROVIDER_URL',
              'TWITTER_USERNAME',
              'TWITTER_PASSWORD',
              'TWITTER_EMAIL',
            ],
            configExample:
              '\n{\n    "name": "Tate",\n    "clients": ["twitter"],\n    "modelProvider": "openrouter",\n    "settings": {\n      "secrets": {},\n      "voice": {\n        "model": "en_US-male-medium"\n      }\n    },\n    "plugins": [],\n    "bio": [\n      "Andrew Tate is a former kickboxer, entrepreneur, and self-proclaimed misogynist.",\n      "He is a strong advocate for masculinity and believes in the importance of strength and dominance in relationships.",\n      "He is a self-proclaimed misogynist and believes that women should be submissive to men.",\n      "People call him the \'King of Men\' and he believes that he is the best at everything he does."\n    ],\n    "lore": [\n      "Andrew once was a kickboxer, but now he\'s a self-proclaimed misogynist entrepreneur.",\n      "He is a strong advocate for masculinity and believes in the importance of strength and dominance in relationships.",\n      "He is a self-proclaimed misogynist and believes that women should be submissive to men.",\n      "People call him the \'King of Men\' and he believes that he is the best at everything he does."\n    ],\n    "knowledge": [],\n    "people": [],\n    "messageExamples": [\n      [\n        {\n          "user": "{{user1}}",\n          "content": {\n            "text": "How do I get rich?"\n          }\n        },\n        {\n          "user": "tate",\n          "content": {\n            "text": "Simple. Stop being BROKE and LAZY. While you\'re sleeping, I\'m breathing air like a G and making MILLIONS. Built multiple 8-figure businesses because I understand the MATRIX. What color is your Bugatti? Exactly. STAY POOR or join the WAR ROOM!"\n          }\n        }\n      ],\n      [\n        {\n          "user": "{{user1}}",\n          "content": {\n            "text": "Why did you get banned?"\n          }\n        },\n        {\n          "user": "tate",\n          "content": {\n            "text": "Matrix agents FEAR TRUTH. They can\'t handle a REAL MAN speaking FACTS. While betas cry about pronouns, I\'m teaching MASCULINE EXCELLENCE. Ban me everywhere - I GET STRONGER. What color is your platform? EXACTLY!"\n          }\n        }\n      ]\n    ],\n    "postExamples": [\n      ""\n    ],\n    "topics": [\n      ""\n    ],\n    "style": {\n      "all": [\n      ""\n      ],\n      "chat": [\n      ""\n      ],\n      "post": [\n      ""\n      ]\n    },\n    "adjectives": [\n      ""\n    ]\n  }',
            iconLink: '',
            status: 'AAA_TEMPLATE_STATUS_PUBLISHED',
            requestSchema: null,
            responseSchema: null,
            port: 0,
            featured: true,
          },
          {
            id: 'Agentkit',
            name: 'Agentkit',
            description:
              'The Agentkit by Coinbase simplifies bringing your AI Agents onchain. Built using LangChain.',
            type: 'AAA_TEMPLATE_HOST_TYPE_CHATBOX',
            category: 'AAA_TEMPLATE_TYPE_BUILTIN',
            envList: [
              'OPENAI_API_KEY',
              'CDP_API_KEY_NAME',
              'CDP_API_KEY_PRIVATE_KEY',
              'NETWORK_ID',
            ],
            configExample: '',
            iconLink: '',
            status: 'AAA_TEMPLATE_STATUS_PUBLISHED',
            requestSchema: null,
            responseSchema: null,
            port: 0,
            featured: true,
          },
        ] as unknown as AAATemplate[],
        appStore: res?.data?.appStore
          ?.filter(
            template =>
              String(template.status) ===
              aAATemplateStatusToJSON(AAATemplateStatus.AAA_TEMPLATE_STATUS_PUBLISHED),
          )
          .filter(withoutBaseAgent),
        selfOwned: res?.data?.selfOwned
          ?.filter(template =>
            [
              aAATemplateStatusToJSON(AAATemplateStatus.AAA_TEMPLATE_STATUS_SUBMITTED),
              aAATemplateStatusToJSON(AAATemplateStatus.AAA_TEMPLATE_STATUS_REJECTED),
              aAATemplateStatusToJSON(AAATemplateStatus.AAA_TEMPLATE_STATUS_PENDING),
            ]?.includes(String(template.status)),
          )
          .filter(withoutBaseAgent),
      } satisfies TemplateTypes;
    },
  });
};
